import getChimeContext from 'contexts/ChimeContext';
import { useContext, useEffect, useRef, useState } from 'react';

export default function useTranscription() {
  const chimeContext = useContext(getChimeContext());
  const chime = useRef(chimeContext);
  chime.current = chimeContext;
  const [transcription, setTranscription] = useState(chime.current?.transcription);
  useEffect(() => {
    const currentChime = chime.current;
    const callback = (newTranscription) => {
      setTranscription(newTranscription);
    };
    if (currentChime) {
      currentChime.subscribeToTranscriptionUpdate(callback);
    }
    return () => {
      currentChime.unsubscribeFromTranscriptionUpdate(callback);
    };
  }, []);
  return transcription;
}
